import React, { useEffect } from 'react'
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Early_Leaving_Policy from './Early_Leaving_Policy'
import Late_Coming_Policy from './Late_Coming_Policy';
import OverTime_Pay_Policy from './OverTime_Pay_Policy';
import { useGlobalContext } from '../../../../Context/GlobalContext';

const Penalty_Overtime = () => {

  
  return (
    <div className="mt-[20px] Penalty-Overtime-Tab">
      <div className="tabs-attendance">
        <Tabs> 
        <TabList className="flex lg:flex-row xl:flex-row flex-col gap-[10px] mb-[20px] text-center">       
            <Tab><button>Early Leaving Policy</button></Tab>
            <Tab><button>Late Coming Policy</button></Tab>
            <Tab><button>Overtime Pay Policy</button></Tab>
        </TabList>

        <TabPanel><Early_Leaving_Policy/></TabPanel>
        <TabPanel><Late_Coming_Policy/></TabPanel>
        <TabPanel><OverTime_Pay_Policy/></TabPanel>
      </Tabs>
      </div>
    </div>
  )
}

export default Penalty_Overtime